let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5iVCs")).then(() => parcelRequire('5xx4Y'));